import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import {
  jumpToWallet,
  closeWebview,
} from 'src/helper/webviewFun'
import config from 'src/core/config'
import VConsole from 'src/helper/vconsole'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    loading: false,
    lang: langM.ar,
    language: '2',
    // GameURL: '',
    uid: 0,
    accesstoken: '',
    appId: 0
  }

  async componentWillMount() {
    let { language, uid, accesstoken, gid, app, appId } = this.props.location.query
    language = await getlang(language)
    console.log("language", language)

    let langObj = {
      'tr': '10',
      'en': '2',
      'ar': '7',
      'zh': '2',
      'ru': '13',
      'id': '3',
      'pt': '9',
      'uz': '23',
      'fa': '19',
      'ur': '11'
    }

    this.setState({
      lang: setlang(language, langM),
      language: langObj[language] || '2',
      uid: uid,
      gid: gid,
      accesstoken: accesstoken,
      app: app || 'baishun',
      appId: appId || 0
      // GameURL: GameURL
    })
    // await this.storeGameBaisun.GetUserInfoWeb(uid)
    await this.RunOnStart(uid)
    const isProd = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'uat'
    if (!isProd) {
      new VConsole()
    }
  }

  //初始化
  RunOnStart = async (uid) => {
  }

  getConfig = (jsCallback) => {
    console.log("收到游戏getConfig")
    //TODO 业务侧根据对接文档,填充相应数据
    let { uid, accesstoken, gid, language, app, appId } = this.state

    var getConfigData = {
      appChannel: "hoby",
      appId: appId,
      userId: uid + '',
      code: accesstoken,
      roomId: gid + '',
      gameMode: "2",
      language: language,
      gameConfig: {
        sceneMode: 0,
        currencyIcon: "https://img.chatie.live/app/source/gold3.png"
      },
      gsp: 201 //游戏正式服务器节点：101-新加坡(阿里云)，201-迪拜AWS，301-硅谷(阿里云)，401-法兰克福(阿里云)
    }
    const isProd = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'uat'
    if (!isProd) {
      getConfigData.gsp = 101
      getConfigData.appId = appId
      console.log('app', app)
      console.log('appId', getConfigData.appId)
    }
    console.log('app', app)
    console.log('getConfigData', getConfigData)
    this.sendDataToGame(jsCallback, getConfigData)
  }

  sendDataToGame = (jsMethods, c) => {
    var data = {
      jsMethods: jsMethods,
      jsData: JSON.stringify(c)
    }
    const iFrame = document.getElementById('iframe');
    iFrame.contentWindow.postMessage(data, '*');
    console.log("sendDataToGame", data)
  }

  componentDidMount() {
    // setTimeout(() => {
    const iFrame = document.getElementById('iframe');
    iFrame.onload = () => {
      // 阻止浏览器默认行为，允许文件拖入到 dropzone 区域
      window.addEventListener('message', (e) => {
        console.log("addEventListener 收到消息", e)
        if (e.data) {
          var data = JSON.parse(e.data);
          var jsCallback = data.jsCallback;
          if (jsCallback.includes("getConfig")) {
            this.getConfig(jsCallback)
          } else if (jsCallback.includes("destroy")) {
            console.log("收到游戏destroy")
            closeWebview()
            //TODO 业务侧销毁iframe
          } else if (jsCallback.includes("gameRecharge")) {
            console.log("收到游戏gameRecharge")
            jumpToWallet()
            //TODO 业务侧弹窗商城
          }
          else if (jsCallback.includes("gameLoaded")) {
            console.log("收到游戏gameLoaded")
            //TODO 业务侧移除加载动画
          } else if (jsCallback.includes("walletUpdate")) {
            jumpToWallet()
            //TODO 业务侧移除加载动画
          }
        }
      })
    }
    // }, 0)
  }

  render() {
    let { GameURL } = this.props.location.query
    return (
      <div className={`game1`}>
        {GameURL && GameURL != '' && <iframe
          className="app-games-iframe"
          id='iframe'
          src={`${GameURL}`}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture">
        </iframe>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/game-baisun-v2/index.js